var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInsta(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 62.505,
    height: 62.505,
    viewBox: "0 0 62.505 62.505",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_2598",
    "data-name": "Groupe 2598",
    transform: "translate(-980.5 -730.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_2460",
    "data-name": "Groupe 2460",
    transform: "translate(197.926 20)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2904",
    "data-name": "Trac\\xE9 2904",
    d: "M61.5,30.753A30.752,30.752,0,1,1,30.753,0,30.752,30.752,0,0,1,61.5,30.753",
    transform: "translate(783.074 710.999)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2937",
    "data-name": "Trac\\xE9 2937",
    d: "M90.337,81.618h15.48a9.119,9.119,0,0,1,9.063,9.089V106.15a9.119,9.119,0,0,1-9.063,9.089H90.337a9.119,9.119,0,0,1-9.063-9.089V90.707a9.119,9.119,0,0,1,9.063-9.089M107.1,87.49h0a1.93,1.93,0,0,1,0,3.861,1.93,1.93,0,0,1,0-3.861m-9.063,1.769h.08a9.169,9.169,0,0,1,0,18.339h-.08a9.17,9.17,0,0,1,0-18.339m0,3.137h.08a6.073,6.073,0,0,1,0,12.145h-.08a6.073,6.073,0,0,1,0-12.145m-7.62-7.883h15.319a6.273,6.273,0,0,1,6.256,6.274V106.07a6.273,6.273,0,0,1-6.256,6.274H90.418a6.273,6.273,0,0,1-6.256-6.274V90.787a6.273,6.273,0,0,1,6.256-6.274",
    transform: "translate(715.749 643.324)",
    fillRule: "evenodd"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsta);
export default __webpack_public_path__ + "static/media/insta.e2d22aa2ac2ac36ae708f4dccf66f09b.svg";
export { ForwardRef as ReactComponent };